import React, { Component } from 'react';
import {Link} from 'react-router-dom';


function Impressum () {
      return (
        <div className="mainContentWrapper">

            <div className="contentContainer">
                
                <div className="contentColumns">
                    <div className="landingleft slideInLeft marginHundred">
                        

                        <p><b>Impressum</b></p>
                        <br/>
                        <p> sys.team software GmbH <br/>
                            Tannenwaldallee 2<br/>
                            D-61348 Bad Homburg
                        </p>    
                            
                        <p> 
                            Telefon: +49 (0)6172 8557810<br/>
                            Telefax: +49 (0)6172 8557839
                        </p>

                        
                    </div>
                    <div className="landingright slideInRight marginHundred">
                        <p>
                            E-Mail: info@sys-team.de<br/>
                            Internet: www.sys-team.de
                        </p>
                        <p>Geschäftsführung: Irmgard Scherer<br/>
                            USt.-ID DE 812 304 665<br/>
                            HRB 10589 Amtsgericht Bad Homburg v. d. Höhe </p>
                    </div>

                </div>

             

                

            </div>

           

        </div>
    )

}

export default Impressum;